import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import Tick from "@/modules/common/components/ui-kit/stepper/tick";
import { StepperStep } from "@/modules/common/components/ui-kit/stepper/stepper";
import { StepState } from "@/modules/common/components/ui-kit/stepper/types";
import { stepperStepStyleMap } from "@/modules/common/components/ui-kit/stepper/constants";

const StepperStepComponent: React.FC<{ step: StepperStep }> = ({ step }) => {
  const theme = useTheme();
  const { FINISHED } = StepState;

  const styles =
    stepperStepStyleMap.get(step.state) || stepperStepStyleMap.get("null")!;

  const stepWidth = "62px";

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        flexShrink: 0,
        flex: "0 0 auto",
        justifyContent: "flex-start",
        width: stepWidth,
      }}
    >
      {/* Step Content */}
      <Stack
        direction="column"
        alignItems="center"
        spacing={theme.nawy.spacing.xxs}
        sx={{
          width: stepWidth,
        }}
      >
        {/* Icon Container */}
        <Box
          sx={{
            position: "relative",
            width: styles.size,
            height: styles.size,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "& img": {
              width: styles.size,
              height: styles.size,
              objectFit: "contain",
            },
            "& svg": {
              width: styles.size,
              height: styles.size,
              "& path": {
                fill: styles.iconColor,
                stroke: styles.iconColor,
              },
            },
          }}
        >
          {step.icon}
          {[FINISHED].includes(step.state) && <Tick />}
        </Box>

        {/* Label */}
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.body.xs.regular,
            color: styles.labelColor,
            textAlign: "center",
            wordBreak: "normal",
            overflowWrap: "normal",
            width: "100%",
            maxWidth: stepWidth,
            // Prevent single words from breaking
            "& span": {
              display: "inline-block",
            },
          }}
        >
          {/* {step.label} */}
          {/* Wrap each word in a span to prevent single-word breaks */}
          {step.label.split(" ").map((word, index, array) => (
            <React.Fragment key={index}>
              <span>{word}</span>
              {index < array.length - 1 ? " " : ""}
            </React.Fragment>
          ))}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default StepperStepComponent;
